import { IsMobileAtom } from "../../../App";
import { useAtom, useAtomValue } from "jotai";
import { useMatch, useParams } from "react-router-dom";

import InnerLink from "./InnerLink";
import { useEffect } from "react";
import { useLocation, Link as RLink } from "react-router-dom";
import { activeLinkAtom, sidebarOpenAtom } from "../../../atoms/SidebarAtoms";
import useHover from "../../../hooks/useHover";

interface Props {
  link: string;
  title: string;
  type: string;
  linkId: string;
  extraPadding?: boolean;
  options?: React.ReactNode;
  isDragging?: boolean;
  icon?: string;
  iconURL?: string;
}

const GrowthCloudLink = ({
  link,
  title,
  type,
  linkId,
  extraPadding = false,
  options = null,
  isDragging = false,
  icon = "",
  iconURL,
}: Props) => {
  const mobileScreen = useAtomValue(IsMobileAtom);
  const [activeLink] = useAtom(activeLinkAtom);
  const [open, setOpen] = useAtom(sidebarOpenAtom);

  const { pageID } = useParams();
  const match = useMatch(
    "/clouds/:tenantID/workspaces/:workspaceID/pages/:pageID/views/:viewID"
  );
  const params = match?.params;
  let finalPageID = params?.pageID || pageID;

  const location = useLocation();
  const [linkRef, isHovered, setIsHovered] = useHover<HTMLAnchorElement>(false);

  useEffect(() => {
    if (!open && isHovered) {
      setIsHovered(false);
    }
  }, [open, isHovered]);

  const handleClickDirectLink = () => {
    if (type !== "PageLink" && type !== "Direct") return;

    if (mobileScreen && open) setOpen(false);
  };

  const isActive =
    location.pathname === link ||
    (finalPageID ? link.includes(finalPageID) : false);

  const DirectLink = (
    <RLink
      id={`tip${linkId}`}
      className={`tw:cursor-pointer tw:px-1 tw:py-[0.41rem] sidebar-link ${
        isActive && "sidebar-link-active"
      } ${extraPadding && open && "pl-4"} ${
        isHovered || activeLink === linkId || isDragging ? "focused-link" : ""
      }
        `}
      onClick={handleClickDirectLink}
      ref={linkRef}
      to={link}
    >
      <InnerLink
        iconURL={iconURL}
        icon={icon}
        isHovered={isHovered}
        linkId={linkId}
        options={options}
        title={title}
      />
    </RLink>
  );

  if (["ModuleLink", "PageLink", "Direct"].includes(type)) return DirectLink;

  const ExternalLink = (
    <a
      id={`tip${linkId}`}
      className={`tw:cursor-pointer tw:px-1 tw:py-[0.41rem] sidebar-link ${
        isActive && "sidebar-link-active"
      } ${extraPadding && open && "pl-4"} ${
        isHovered || activeLink === linkId || isDragging ? "focused-link" : ""
      }
        `}
      ref={linkRef}
      href={link}
      target="_blank"
      rel="noopener noreferrer"
    >
      <InnerLink
        customIcon={"mdi mdi-open-in-new"}
        iconURL={iconURL}
        icon={icon}
        isHovered={isHovered}
        linkId={linkId}
        options={options}
        title={title}
      />
    </a>
  );

  return ExternalLink;
};

export default GrowthCloudLink;
